/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="my-orders-page with-loader-absolute">
    <div class="account-content">
      <div class="account-content__header">
        <orders-filters
          @filtersApplied="loadOrders"
        />
      </div>
      <div class="account-content__body">
        <div v-if="orders.length" class="order-table">
          <div class="orders-total">
            <span>{{ $t('result-found-{q}', { q: orders.length }) }}</span>
          </div>
          <div class="order-table-header">
            <div
              class="single-field"
              v-for="field in fields"
              :key="field.key"
              :class="[field.key]"
            >
              <span v-html="field.label"></span>
            </div>
          </div>
          <div class="order-table-body">
            <template v-for="order in orders">
              <order-card :order="order" :key="order.entity_id" />
            </template>
          </div>
        </div>
        <div v-else class="empty-order my-5">
          <span v-t="'order.orders-empty'"></span>
        </div>
      </div>
      <div class="account-content__footer" v-if="orders.length">
        <pagination
          :total="pagination.total"
          :size="pagination.size"
          :start="pagination.start"
          @changePage="changePage"
        />
      </div>
    </div>
    <absolute-loader :showLoader="showLoader" mode="fixed"></absolute-loader>
  </section>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import assign from 'lodash/assign'
import Pagination from 'theme/components/Pagination/Pagination'
import OrdersFilters from 'theme/components/MyAccount/Orders/OrdersFilters'
import OrderCard from 'theme/components/MyAccount/Orders/OrderCard'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  head () {
    return {
      title: 'Orders'
    }
  },
  data () {
    return {
      showLoader: false,
      fields: [
        {
          key: 'order-n',
          label: this.$t('order-number')
        },
        {
          key: 'shipping-medthod',
          label: this.$t('shipping-method')
        },
        {
          key: 'name-surname',
          label: this.$t('name-surname')
        },
        {
          key: 'tel',
          label: this.$t('tel')
        },
        {
          key: 'packages-n',
          label: this.$t('packages-n')
        },
        {
          key: 'status',
          label: this.$t('status')
        },
        {
          key: 'seller',
          label: this.$t('seller')
        },
        {
          key: 'created-at',
          label: this.$t('created-at')
        },
        {
          key: 'contacts',
          label: '<svg class="o-icon stroke-white"><use xlink:href="#customer-service"></use></svg>'
        }
      ]
    }
  },
  computed: {
    appliedFilters () {
      return this.$store.state.search.filtersApplied
    },
    pagination () {
      return this.$store.state.orders.pagination
    },
    orders () {
      return this.$store.state.orders.list
    }
  },
  methods: {
    changeQuery (query) {
      this.$router.replace({ query }).catch((e) => {
        console.log(e)
      })
    },
    changePage (newOffset = 0) {
      const newQuery = assign({}, this.$route.query, { sz: this.pagination.size, start: newOffset })
      this.changeQuery(newQuery)
    },
    loadOrders (filters, callChangePage = false) {
      this.showLoader = true
      if (callChangePage && this.pagination.start !== parseInt(this.$route.query.start)) {
        this.changePage()
      } else {
        this.$store.dispatch('orders/list', filters).finally((res) => {
          this.showLoader = false
        })
      }
    }
  },
  beforeMount () {
    if (process.client) {
      return this.$store.commit('ui/setHeaderPageTitle', 'manage-orders')
    }
  },
  mounted () {
    let pagination = {}
    pagination.start = parseInt(this.$route.query.start) || 0
    if (!isUndefined(this.$route.query.sz)) {
      pagination.size = parseInt(this.$route.query.sz)
    }
    if (!isEmpty(pagination)) {
      this.$store.commit('orders/setPagination', pagination)
    }
    this.$nextTick(() => {
      this.loadOrders(this.appliedFilters)
    })
  },
  components: {
    AbsoluteLoader,
    Pagination,
    OrdersFilters,
    OrderCard
  }
}
</script>
